module.exports = __webpack_public_path__ + "img/icon-tonglianpay.5cab5a09.png";